// extracted by mini-css-extract-plugin
export default {"complete":"Complete_complete__XNClD","completeBorder":"Complete_completeBorder__BwiV9","innerBorder":"Complete_innerBorder__7iCOa","borderBox":"Complete_borderBox__ZXVHp"};